import { useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { LoadingScreen } from '@planitgeo/treeplotter-ui-library';
import { useAuthContext } from '../infrastructure/useAuthContext';
import { PATH_AUTH } from 'routes/paths';
import { useJwtClaimVerification } from '../infrastructure/useJwtClaimVerification';

export default function AuthGuard() {
  const { isAuthenticated, isInitialized } = useAuthContext();

  const { pathname } = useLocation();

  const [requestedLocation, setRequestedLocation] = useState<string | null>(null);

  // Set up JWT claim verification for authenticated users
  useJwtClaimVerification();

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }
    return <Navigate to={PATH_AUTH.login} />;
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return (
    <>
      <Outlet />
    </>
  );
}
